module.exports = __webpack_public_path__ + "img/PVC_JH1F8_F.1bbce12a.png";